import { render, staticRenderFns } from "./FPassword.vue?vue&type=template&id=0aaf2b3c"
import script from "./FPassword.vue?vue&type=script&lang=js"
export * from "./FPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports